module.exports = __webpack_public_path__ + "img/ulises-castillo.952cd1c3.png";